// safeHref returns the URL only if it is an absolute http(s) URL, else
// undefined. React does not strip `javascript:` hrefs, so any href derived
// from API data must pass through here (T9296).
export function safeHref(url: string | null | undefined): string | undefined {
  if (!url) return undefined
  return /^\s*https?:\/\//i.test(url) ? url : undefined
}
